import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import Link from "next/link";
import { Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import DateRangePicker from "components/date-range";
import { format } from "date-fns";
import moment from "moment";
import {
  breakDown,
  get_cookie,
  setTimeAMPM,
  strToLowerCase,
  calculate_age,
  minimumDayErrorMessage,
  formatMoney,
  makeCountryData,
  makeStatesData,
  VALID_START_DATE,
  isDateLessThanToday,
  makeCityStateSlugUsingLocation,
  clearTimeDateCookieValue,
  hideDriveNow,
  removeFrontZeroFromPhoneNo,
  INPUT_VALIDATOR,
  VEHICLE_UNAVAILABLE_ERROR,
  set_cookie,
} from "../../utils";
import { vehicleBookingSchema } from "../../utils/validationSchema";
import TimePicker from "../../components/time-picker";
import MakesSelect from "../../components/select-vehicle/makes-select";
import BookingSteps from "../../components/bookingSteps";
import DynamicLayout from "../../components/layout/dynamicLayout";
import TelInputFunctional from "components/phoneInput";
import ModelSelect from "components/select-vehicle/modal-select";
import {
  bookingRequest,
  bookingSave,
  getAddressInfo,
  getBrandInfo,
  getBrandList,
  getLocations,
  getReservationDetails,
  login,
  submitOtp,
  toggleLoader,
  getVehicalDetailData,
  getCountryList,
  getStateList,
  toggleModal,
  getAvailableSlot,
} from "store/actions";
import PriceDetail from "components/priceDetail";
import CarDetailInfo from "components/carDetailInfo";
import BreakDownModal from "components/modals/breakDownModal";
import VerifyUserExistOtpModal from "components/modals/verifyUserExistOtp";
import MainModal from "components/modals/mainModal";
import EmailQuoteSuccess from "components/modals/emailQuoteSuccess";
import Fournotfour from "components/fournotfour";
import { userPhoneExist } from "store/actions/user";
import {
  resetVehicleAvailableForDriveNow,
  setVehicleAvailableForDriveNow,
} from "store/reducers/vehicle";
import PickupAddress from "components/bookingSteps/pickupAddress";

//Internal
import { ButtonLoader } from "components/loader/ButtonLoader";
//Internal

const VehicleBooking = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const ref = useRef();
  const currentLocationId = get_cookie("currentLocationId");
  const user = useSelector((state1) => state1?.user?.userInfo);
  const addressInfo = useSelector((state) => state?.common?.addressInfo);
  const match =
    addressInfo &&
    addressInfo?.company_address?.match(INPUT_VALIDATOR?.addressPattern);
  const userToken = useSelector((state1) => state1?.user);
  const brandList = useSelector((state2) => state2?.common?.brandList);
  const brandVehicleList = useSelector(
    (state3) => state3?.common?.brandVehicleList
  );
  const loaders = useSelector((state) => state?.ui?.loaders);
  const [homeAddress, sethomeAddress] = useState(false);
  const [currentLocationStateName, setCurrentLocationStateName] = useState();
  const [dropoffStateName, setDropoffStateName] = useState();
  const [selectedMake, setSelectedMake] = useState();
  const [selectedModal, setSelectedModal] = useState();

  const [countryOptions, setCountryOptions] = useState([]);
  const [countryIso, setcountryIso] = useState("US");
  const [state, setState] = useState("");
  const [value, setValue] = useState("");
  const [countryFlag, setCountryFlag] = useState("");
  const [numValidation, setNumValidation] = useState({
    valid: false,
    error: "",
  });
  const [isKeyboard, setIsKeyboard] = useState(false);
  // const [height, setHeight] = useState(0);

  const [countryCode, setCountryCode] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  // Terms & Condition Modal
  const [verifyUserExistOtp, setVerifyUserExistOtp] = useState(false);
  const verifyUserExistOtpClose = () => setVerifyUserExistOtp(false);
  const verifyUserExistOtpShow = () => setVerifyUserExistOtp(true);

  const [toggle, toggleUdMob] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showCompleteProfileModal, setShowCompleteProfileModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [validStartDate, setValidStartDate] = useState(false);
  const [minimumDay, setMinimumDay] = useState(1);
  const [verifyOtpError, setVerifyOtpError] = useState("");
  const [vehicleAvablityError, setVehicleAvablityError] = useState("");
  const [deliveryFee, setDeliveryFee] = useState(null);
  const [returnFee, setReturnFee] = useState(null);
  const [stateShortName, setStateShortName] = useState("CA");
  const [dropoffStateShortName, setDropoffStateShortName] = useState("CA");
  const [age, setAge] = useState(0);
  const [returnMiles, setReturnMiles] = useState();
  const [deliveryMiles, setDeliveryMiles] = useState();
  const [streetAddress, setStreetAddress] = useState();
  const [stateShortname, setStateShortname] = useState();
  const [city, setCity] = useState();
  const [zipCode, setZipCode] = useState();
  const [isMobileApp, setIsMobileApp] = useState();
  const [noSlotError, setNoSlotError] = useState("")
  const [noVehicleError, setNoVehicleError] = useState("");

  /*******************
  @Purpose : React Hook with dependencies
  @Parameter : {}
  @Author : INIC
  *******************/
  useEffect(() => {
    if (user) {
      setTimeout(() => {
        formik.setFieldValue("email", user?.email);
        formik.setFieldValue("first_name", user?.first_name);
        formik.setFieldValue("last_name", user?.last_name);

        setContactNumber(user?.contact_number ? user?.contact_number : "");
        setCountryCode(user?.country_code ? user?.country_code : "");
        setcountryIso(user?.country_shortname?.sortname);
        setValue(user?.contact_number ? user?.contact_number : "");
        setCountryFlag(user?.country_shortname?.sortname?.toLowerCase());

        let age = "";
        let age_group = "";
        let start_age = "";
        if (user?.date_of_birth) {
          age = calculate_age(user?.date_of_birth);

          if (age) {
            if (age > 17 && age < 21) {
              age_group = "18-20";
              start_age = "18+";
            } else if (age > 20 && age < 25) {
              age_group = "21-24";
              start_age = "21+";
            } else {
              age_group = "25+";
              start_age = "25+";
            }
            formik.setFieldValue("age", age_group);
            formik.setFieldValue("startAge", start_age);
          }
        }

        setNumValidation({
          valid: true,
          error: "",
        });
      }, 800);
    }
  }, [user]);

  useEffect(() => {
    let tempCityStateSlug = get_cookie("cityStateSlug");
    dispatch(getBrandList(currentLocationId));
    dispatch(getLocations()).then((res) => {
      res?.forEach(function (location) {
        const checkCityStateSlug = makeCityStateSlugUsingLocation(location);
        if (tempCityStateSlug == checkCityStateSlug) {
          setCurrentLocationStateName(strToLowerCase(location.state_name));
          if (strToLowerCase(location.state_name) != "california") {
            setStateShortName("FL");
          } else {
            setStateShortName("CA");
          }
        }
      });
    });

    dispatch(getCountryList()).then((res) => {
      setCountryOptions(makeCountryData(res));
      res?.map((country) => {
        if (strToLowerCase(country.sortname) == "us") {
          dispatch(getStateList(country?.id)).then((states) => {
            setState(makeStatesData(states));
          });
        }
      });
    });

    // Check Start date is less today
    if (localStorage?.getItem("valid_start_date")) {
      setValidStartDate(true);
      localStorage.removeItem("valid_start_date");
    }
  }, []);

  /*******************
  @purpose : location details (pickup vs delivery, one-way, delivery/return
             addresses) the customer already picked on the search-results
             toolbar, carried over via the same selectedLocationDraft cookie
             the homepage search bars write - so clicking a vehicle card
             doesn't reset the customer back to the plain-pickup default.
  @Author : INIC
  ******************/
  const carriedLocationDraft = useMemo(() => {
    try {
      return JSON.parse(get_cookie("selectedLocationDraft") || "null");
    } catch (e) {
      return null;
    }
  }, []);

  /*******************
  @Purpose : Formik Hooks for form validation
  @Parameter : {}
  @Author : INIC
  *******************/
  const formik = useFormik({
    initialValues: {
      email: "",
      first_name: "",
      last_name: "",
      age: "",
      delivery_type: false,
      is_pickup_selected: carriedLocationDraft?.activeTab !== "delivery",
      pickup_option: carriedLocationDraft?.activeTab === "delivery",
      one_way_option: carriedLocationDraft?.oneWay || false,
      address:
        carriedLocationDraft?.activeTab === "delivery"
          ? carriedLocationDraft.deliveryStreetAddress || ""
          : "",
      country: "United States",
      state: "",
      city:
        carriedLocationDraft?.activeTab === "delivery"
          ? carriedLocationDraft.deliveryCity || ""
          : "",
      zipcode:
        carriedLocationDraft?.activeTab === "delivery"
          ? carriedLocationDraft.deliveryZipcode || ""
          : "",
      dropoff_option: "office",
      dropoff_address: carriedLocationDraft?.oneWay
        ? carriedLocationDraft.returnStreetAddress || ""
        : "",
      dropoff_city: carriedLocationDraft?.oneWay
        ? carriedLocationDraft.returnCity || ""
        : "",
      dropoff_zipcode: carriedLocationDraft?.oneWay
        ? carriedLocationDraft.returnZipcode || ""
        : "",
      dropoff_state: "",
      dropoff_country: "",
      start_address:
        carriedLocationDraft?.activeTab === "delivery"
          ? carriedLocationDraft.deliveryAddress || ""
          : "",
      end_address: "",
      return_address: carriedLocationDraft?.oneWay
        ? carriedLocationDraft.returnAddress || ""
        : "",
      return_address_city: "",
      return_address_zipcode: "",
      return_address_country: "",
      return_address_state: "",
      startAge: "",
    },
    enableReinitialize: true,
    validationSchema: vehicleBookingSchema,
    onSubmit: async () => {
      if (isDateLessThanToday(startDate)) {
        setValidStartDate(true);
      } else {

        if (vehicalDetailData?.id) {
          // Calculate start and end dates for the two-month period
          const start_date = moment(startDate).format("YYYY-MM-DD");
          const end_date = moment(endDate).format("YYYY-MM-DD");
          const startTime = startTimeDefaultValue
          const endTime = endTimeDefaultValue
          const res = await dispatch(
            getAvailableSlot(
              get_cookie("currentLocationId"),
              vehicalDetailData?.id,
              start_date,
              end_date, "submit", "", startTime?.replace(":00", ""), endTime.replace(":00", "")
            ))
          if (breakDownObj.days >= vehicalDetailData?.minimum_days && res?.common_vehicles?.length > 0) {
            if (user) {

              const bookingdata = makeBookingDataObj();
              setLoader(true);
              dispatch(bookingSave(bookingdata))
                .then((res) => {
                  if (res?.id) {
                    const bookingRequestData = {
                      location_id: currentLocationId,
                      type: "reservation",
                      vehicle_booking_id: res.id,
                    };
                    dispatch(bookingRequest(bookingRequestData));
                    clearTimeDateCookieValue();
                    //as per client reqirements we add delay to show full loader
                    setTimeout(() => {
                      router.push(`/reservation/${res.id}`);
                    }, 1000);
                    // setLoader(false);
                    setVehicleAvablityError("");
                    setNoSlotError("")
                    setNoVehicleError("")
                  }
                })
                .catch((err) => {
                  setLoader(false);
                  setVehicleAvablityError(
                    err?.message === "There are no vehicle available."
                      ? VEHICLE_UNAVAILABLE_ERROR
                      : err?.message
                  );
                });
            } else {
              const phoneData = {
                country_code: countryCode,
                contact_number: contactNumber,
                country_shortname: countryIso,
              };
              setLoader(true);
              dispatch(userPhoneExist(phoneData)).then((res) => {
                if (res.success) {
                  setLoader(false);
                  verifyUserExistOtpShow();
                } else {
                  const bookingdata = makeBookingDataObj();
                  dispatch(bookingSave(bookingdata))
                    .then((res1) => {
                      if (res1?.id) {
                        const bookingRequestData = {
                          location_id: currentLocationId,
                          type: "reservation",
                          vehicle_booking_id: res1.id,
                        };
                        dispatch(bookingRequest(bookingRequestData));
                        clearTimeDateCookieValue();
                        //as per client reqirements we add delay to show full loader
                        setTimeout(() => {
                          router.push(`/reservation/${res1.id}`);
                        }, 1000);
                        // setLoader(false);
                        setVehicleAvablityError("");
                        setNoSlotError("")
                        setNoVehicleError("")
                      }
                    })
                    .catch((err) => {
                      setLoader(false);
                      setVehicleAvablityError(
                        err?.message === "There are no vehicle available."
                          ? VEHICLE_UNAVAILABLE_ERROR
                          : err?.message
                      );
                    });
                }
              });
            }
          } else {
            setNoVehicleError("No vehicle available for this date, please select a different date range.");
          }
        }
      }
    },
  });
  const verfiyUserExistOtpSubmit = (otp) => {
    const verfiyUserExistOtpData = {
      country_code: countryCode,
      contact_number: contactNumber,
      country_shortname: countryIso,
      otp: otp,
    };
    dispatch(submitOtp(verfiyUserExistOtpData, false))
      .then(() => {
        // when user entered right otp
        const bookingdata = makeBookingDataObj();
        setLoader(true);
        dispatch(bookingSave(bookingdata))
          .then((res) => {
            if (res?.id) {
              const bookingRequestData = {
                location_id: currentLocationId,
                type: "reservation",
                vehicle_booking_id: res.id,
              };
              dispatch(bookingRequest(bookingRequestData));
              clearTimeDateCookieValue();
              verifyUserExistOtpClose();
              if (!userToken?.token && isMobileApp === "yes") {
                router.push(`/reservation/${res.id}?is_app_login=yes`);
                // setLoader(false);
              } else {
                //as per client reqirements we add delay to show full loader
                setTimeout(() => {
                  router.push(`/reservation/${res.id}`);
                }, 1000);
                // setLoader(false);
                dispatch(toggleModal(true, "welcomeMessage"));
              }
              setVehicleAvablityError("");
              setNoSlotError("")
              setNoVehicleError("")
            }
          })
          .catch((err) => {
            setLoader(false);
            setVehicleAvablityError(
              err?.message === "There are no vehicle available."
                ? VEHICLE_UNAVAILABLE_ERROR
                : err?.message
            );
          });
      })
      .catch((err) => {
        setLoader(false);
        // user entered wrong otp
        setVerifyOtpError("");
        setTimeout(() => {
          setVerifyOtpError(err.message);
        });
      });
  };

  const continueAsGuest = () => {
    const bookingdata = makeBookingDataObj();

    dispatch(bookingSave(bookingdata))
      .then((res) => {
        if (res?.id) {
          const bookingRequestData = {
            location_id: currentLocationId,
            type: "reservation",
            vehicle_booking_id: res.id,
          };
          dispatch(bookingRequest(bookingRequestData));
          clearTimeDateCookieValue();
          verifyUserExistOtpClose();
          router.push(`/reservation/${res.id}`);
          setVehicleAvablityError("");
          setNoSlotError("")
          setNoVehicleError("")
        }
      })
      .catch((err) => {
        setLoader(false);
        setVehicleAvablityError(
          err?.message === "There are no vehicle available."
            ? VEHICLE_UNAVAILABLE_ERROR
            : err?.message
        );
        verifyUserExistOtpClose();
      });
  };

  const emailMeQuota = () => {
    const bookingdata = makeBookingDataObj();
    dispatch(bookingSave(bookingdata, false))
      .then((res) => {
        const bookingRequestData = {
          location_id: currentLocationId,
          type: "quote",
          vehicle_booking_id: res.id,
        };
        dispatch(bookingRequest(bookingRequestData)).then(() => {
          setShowEmailQuote(true);
          if (isMobile) {
            handleClose();
          }
        });
        setVehicleAvablityError("");
      })
      .catch((err) => {
        setLoader(false);
        setVehicleAvablityError(
          err?.message === "There are no vehicle available."
            ? VEHICLE_UNAVAILABLE_ERROR
            : err?.message
        );
      });
  };

  const makeBookingDataObj = () => {
    let dropoff_address = "";
    let dropoff_city = "";
    let dropoff_zipcode = "";
    let dropoff_state = "";
    let dropoff_state_shortname = "";
    let dropoff_country = "";
    let dropoff_country_shortname = "";
    let isDeliveryTbd = false;
    let isReturnTbd = false;
    const deliveryCharge =
      !values?.one_way_option &&
        deliveryFee !== "" &&
        deliveryFee !== null &&
        deliveryFee >= 0
        ? deliveryFee / 2
        : deliveryFee;
    const returnFees =
      !values?.one_way_option &&
        !values?.is_pickup_selected &&
        deliveryFee !== "" &&
        deliveryFee !== null &&
        deliveryFee >= 0
        ? deliveryFee / 2
        : returnFee;

    if (
      !values?.pickup_option ||
      (deliveryFee !== "" && deliveryFee !== null && deliveryFee >= 0)
    ) {
      isDeliveryTbd = false;
    } else {
      isDeliveryTbd = true;
    }
    if (
      !formik?.values?.one_way_option ||
      (returnFee !== "" && returnFee !== null && returnFee >= 0)
    ) {
      isReturnTbd = false;
    } else {
      isReturnTbd = true;
    }
    if (values.one_way_option && values.dropoff_address) {
      dropoff_address = values.dropoff_address.trim();
      dropoff_city = values.dropoff_city.trim();
      dropoff_zipcode = values.dropoff_zipcode.trim().replace(/\s/g, "");
      dropoff_state = dropoffStateName;
      dropoff_state_shortname = dropoffStateShortName;
      dropoff_country = "United States";
      dropoff_country_shortname = countryIso?.toUpperCase();
    } else {
      dropoff_address = values.address.trim();
      dropoff_city = values.city.trim();
      dropoff_zipcode = values.zipcode.trim().replace(/\s/g, "");
      dropoff_state = currentLocationStateName;
      dropoff_state_shortname = stateShortName;
      dropoff_country = "United States";
      dropoff_country_shortname = countryIso?.toUpperCase();
    }
    return {
      booking_id: router?.query?.booked_id,
      location_id: currentLocationId,
      vehicle_id: vehicalDetailData?.id,
      start_date: startDate + " " + setTimeAMPM(parseInt(startTimeDefaultValue?.split(":")[0], 10)),
      end_date: endDate + " " + setTimeAMPM(parseInt(endTimeDefaultValue?.split(":")[0], 10)),
      first_name: values.first_name.trim(),
      last_name: values.last_name.trim(),
      email: values.email.trim(),
      age: values.age,
      country_code: countryCode,
      contact_number: contactNumber,
      delivery_info: 0,
      delivery_type: values.pickup_option ? "delivery" : "pickup",
      address: values.pickup_option ? values.address.trim() : streetAddress,
      country: "United States",
      state: currentLocationStateName,
      city: values.pickup_option ? values.city.trim() : city,
      zipcode: values.pickup_option
        ? values.zipcode.trim().replace(/\s/g, "")
        : zipCode,
      country_shortname: countryIso?.toUpperCase(),
      delivery_fees: deliveryCharge && deliveryCharge >= 0 ? deliveryCharge : 0,
      state_shortname: stateShortName ? stateShortName : stateShortname,
      // dropoff_type,
      dropoff_address: dropoff_address ? dropoff_address : streetAddress,
      dropoff_city: dropoff_city ? dropoff_city : city,
      dropoff_zipcode: dropoff_zipcode ? dropoff_zipcode : zipCode,
      dropoff_state,
      dropoff_state_shortname: dropoff_state_shortname
        ? dropoff_state_shortname
        : stateShortname,
      dropoff_country,
      dropoff_country_shortname,
      // return_address: values?.return_address,
      return_fees: returnFees && returnFees >= 0 ? returnFees : 0,
      return_miles: returnMiles,
      delivery_miles: deliveryMiles,
      // ReturnType: formik?.values?.return_address && "oneWay",
      is_one_way: formik?.values?.one_way_option,
      is_delivery_tbd: isDeliveryTbd,
      is_return_tbd: isReturnTbd,
    };
  };

  const ResendOtp = () => {
    setVerifyOtpError("");
    let loginData = {
      country_code: countryCode,
      contact_number: contactNumber,
      country_shortname: countryIso?.toUpperCase(),
    };
    dispatch(login(loginData));
  };

  useEffect(() => {
    if (match) {
      const streetAddress = match[1].trim(); // "499 N Canon Dr"
      const city = match[2].trim(); // "Beverly Hills"
      const state_shortname = match[3].trim(); // "CA"
      const zipcode = match[4].trim();

      setStreetAddress(streetAddress);
      setCity(city);
      setStateShortname(state_shortname);
      setZipCode(zipcode);
    } else {
      setStreetAddress("");
      setCity("");
      setStateShortname("");
      setZipCode("");
    }
  }, [match]);

  useEffect(() => {
    commonBreakDown();
  }, [deliveryFee, returnFee]);

  /*** code end here for delievery */

  /*******************
  @Purpose : Used for handle change in phone number
  @Parameter : {value, country}
  @Author : INIC
 *******************/
  const handleInputChange = (val, country, isValid) => {
    setContactNumber(val);
    setCountryCode(`+${country.dialCode}`);

    if (isValid) {
      setNumValidation({
        valid: true,
        error: "",
      });
    } else {
      setNumValidation({
        valid: false,
        error: "",
      });
    }
    setcountryIso(country.iso2);
  };

  /*******************
  @Purpose : Formik Properties
  @Parameter : {}
  @Author : INIC
  *******************/
  const { values } = formik;

  /*******************
  @purpose : set init values
  @Author : INIC
  ******************/
  const stateObj = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ];
  const [isShowCalendar, setIshowCalendar] = useState(false);
  const [dateObj, setDateObj] = useState(stateObj);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isFirstTimeLoad, setIsFirstTimeLoad] = useState(true);
  const [isReserveEnable, setIsReserveEnable] = useState(true);
  const [breakDownObj, setBreakDownObj] = useState({});
  const [isPageLoad, setIsPageLoad] = useState(true);

  // time options
  const [startDateTimeOptions, setStartDateTimeOptions] = useState([]);
  const [endDateTimeOptions, setEndDateTimeOptions] = useState([]);
  const [startTimeDefaultValue, setStartTimeDefaultValue] = useState(null);
  const [endTimeDefaultValue, setEndTimeDefaultValue] = useState(null);

  const [vehicalDetailData, setVehicalDetailData] = useState();
  const [bookedTimeDateDetail, setBookedTimeDateDetail] = useState({});
  const [isEmailMeShow, setIsEmailMeShow] = useState(false);
  const [isShowHomeAddress, setIsShowHomeAddress] = useState(false);
  const [globalSetting, setGlobalSetting] = useState({});
  const [ageBookedId, setAgeBookedId] = useState("");
  const [loader, setLoader] = useState(false);

  /*******************
  @purpose : get vehicle data using slug from query
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    dispatch(toggleLoader("button_loader", false));
    dispatch(toggleLoader("page_loader", true));
    const { booked_id } = router.query;

    const slug = get_cookie("vSlug");
    const brandId = get_cookie("brandId");

    dispatch(
      getAddressInfo(get_cookie("currentLocationId"), false, false)
    ).then((res) => {
      setGlobalSetting(res);

      if (brandId && slug) {
        dispatch(
          getVehicalDetailData(get_cookie("currentLocationId"), slug)
        ).then((res1) => {
          setVehicalDetailData(res1?.vehicle);

          // set modal information
          setModalInfoIfExistInURL(res1?.vehicle?.name, res1?.vehicle?.slug);
          // set brand information
          if (brandId) {
            setMakeInfoIfExistInURL(brandId);
          }
        });
      } else if (booked_id) {
        dispatch(getReservationDetails(booked_id))
          .then((res2) => {
            formik.setFieldValue("email", res2.email);
            formik.setFieldValue("first_name", res2.first_name);
            formik.setFieldValue("last_name", res2.last_name);

            if (res?.delivery_type == "delivery") {
              formik.setFieldValue("delivery_type", true);
              formik.setFieldValue("address", res2?.address);
              formik.setFieldValue("city", res2?.city);
              formik.setFieldValue("zipcode", res2?.zipcode);
            } else {
              formik.setFieldValue("address", "");
              formik.setFieldValue("city", "");
              formik.setFieldValue("zipcode", "");
            }

            const arr = res2.phone.split(" ");
            let phoneStr = "";
            let countryCodeStr = "";

            countryCodeStr = arr["0"];

            for (let i = 1; i < arr.length; i++) {
              if (phoneStr) {
                phoneStr = phoneStr + " " + arr[i];
              } else {
                phoneStr = arr[i];
              }
            }
            setCountryFlag(res2?.country_shortname?.toLowerCase());
            setValue(phoneStr);

            setContactNumber(phoneStr);
            setCountryCode(countryCodeStr);

            setNumValidation({
              valid: true,
              error: "",
            });

            let tempAge = res2?.age;
            formik.setFieldValue("age", tempAge);
            setAgeBookedId(tempAge);

            const brandId1 = res2?.brand_id;
            const obj = {
              bookedStartDate: res?.start_date,
              bookedStartTime: res?.start_time,
              bookedEndDate: res?.end_date,
              bookedEndTime: res?.end_time,
            };
            setBookedTimeDateDetail(obj);
            dispatch(
              getVehicalDetailData(
                get_cookie("currentLocationId"),
                res2?.vehicle?.slug,
                false
              )
            ).then((res3) => {
              setVehicalDetailData(res3?.vehicle);
              // set modal information
              setModalInfoIfExistInURL(
                res3?.vehicle?.name,
                res3?.vehicle?.slug
              );
              // set brand information
              if (brandId1) {
                setMakeInfoIfExistInURL(brandId1);
              }
            });
          })
          .catch(() => {
            dispatch(toggleLoader("page_loader", false));
            setIsValidUrl(false);
          });
      } else {
        dispatch(toggleLoader("page_loader", false));
      }
    });

    if (user?.email) {
      setIsEmailMeShow(true);
    }
  }, []);

  const setMakeInfoIfExistInURL = (brandId) => {
    dispatch(getBrandInfo(get_cookie("currentLocationId"), brandId, false))
      .then((res) => {
        const tempSelectedMake = {
          label: res?.name,
          value: res?.id,
          image: res?.image,
        };
        setSelectedMake(tempSelectedMake);
        dispatch(toggleLoader("page_loader", false));
      })
      .catch(() => {
        setIsValidUrl(false);
        dispatch(toggleLoader("page_loader", false));
      });
  };

  const setModalInfoIfExistInURL = (label1, value1) => {
    const tempSelectedModal = {
      label: label1,
      value: value1,
    };
    setSelectedModal(tempSelectedModal);
  };

  /*******************
  @purpose : Set init date and time if available
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    if (vehicalDetailData) {
      if (vehicalDetailData?.drive_now_status) {
        dispatch(setVehicleAvailableForDriveNow());
      } else {
        dispatch(resetVehicleAvailableForDriveNow());
      }
      setInitDate();
      setMinimumDay(
        vehicalDetailData?.minimum_days ? vehicalDetailData?.minimum_days : 1
      );
      // Retry the time-cookie read once real vehicle data has loaded -
      // commonBreakDown's own isPageLoad-gated read (fired on mount, before
      // this network round trip even starts) can lose a race against the
      // previous page's cookie-write effect on a very fast vehicle-card
      // click. By now that write has had time to land, same margin
      // setInitDate above already relies on for dates.
      if (isPageLoad) {
        commonBreakDown(vehicalDetailData, age);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicalDetailData]);

  /*******************
  @purpose : Set Init Date
  @Parameter : {}
  @Author : INIC
  ******************/
  const setInitDate = () => {
    if (vehicalDetailData) {
      let currentMonth = ""
      let start_date = ""
      let end_date = ""
      // const dateString = get_cookie("month_range")
      // const date = dateString ? JSON.parse(dateString) : {}; // Parse JSON if exists
      if (get_cookie("daterange")) {
        const dateArr = get_cookie("daterange").split("|");
        currentMonth = moment(dateArr[0]).startOf("month");
        start_date = currentMonth.format("YYYY-MM-DD");
        end_date = moment(dateArr[1]).endOf('month').format("YYYY-MM-DD");
      } else {
        currentMonth = moment().startOf('month');
        start_date = currentMonth.format("YYYY-MM-DD");
        end_date = moment(currentMonth).add(1, 'month').endOf('month').format("YYYY-MM-DD");
      }
      dispatch(getAvailableSlot(currentLocationId, vehicalDetailData?.id, start_date, end_date, get_cookie("daterange") ? "end_date" : "start_date", ""))
      if (get_cookie("daterange")) {
        // daterange available in query string
        const dateArr = get_cookie("daterange").split("|");
        // hide drive now section if time diff between selected date and current date is more than 2 days
        hideDriveNow(dateArr[0]);
        setStartDate(dateArr[0]);
        setEndDate(dateArr[1]);
        const makeDateObj = {
          startDate: new Date(dateArr[0]),
          endDate: new Date(dateArr[1]),
          key: "selection",
        };
        setDateObj([makeDateObj]);
        startTimeOptionsHandler(makeDateObj);
      } else if (router?.query?.booked_id) {
        // booking_id available in query string
        const startArr = bookedTimeDateDetail?.bookedStartDate?.split("-");
        const endArr = bookedTimeDateDetail?.bookedEndDate?.split("-");

        let startDateYear = startArr[0];
        let startDateMonth = parseInt(startArr[1], 10) - 1;
        let startDateDay = parseInt(startArr[2], 10);

        let endDateYear = endArr[0];
        let endDateMonth = parseInt(endArr[1], 10) - 1;
        let endDateDay = parseInt(endArr[2], 10);

        const date1 = new Date(startDateYear, startDateMonth, startDateDay);
        const date2 = new Date(endDateYear, endDateMonth, endDateDay);

        setStartDate(format(date1, "MMM d, yyyy", {}));
        setEndDate(format(date2, "MMM d, yyyy", {}));

        const makeDateObj = {
          startDate: date1,
          endDate: date2,
          key: "selection",
        };
        setDateObj([makeDateObj]);
        startTimeOptionsHandler(makeDateObj);
      }
    }
  };

  /*******************
  @purpose : Set start options and end options
  @Parameter : {date}
  @Author : INIC
  ******************/
  const startTimeOptionsHandler = (dateObj1) => {
    setIsFirstTimeLoad(false);
  };

  useEffect(() => {
    changeTimeBreakDown(vehicalDetailData);
  }, [startTimeDefaultValue, endTimeDefaultValue, vehicalDetailData, dateObj]);

  const changeTimeBreakDown = (vehicleDetail) => {
    if (!isFirstTimeLoad && endTimeDefaultValue) {
      commonBreakDown(vehicleDetail, age);
      setIsReserveEnable(false);
    } else {
      setBreakDownObj({});
      setIsReserveEnable(true);
    }


  };

  /*******************
  @purpose : call breakdown function
  @Parameter : {}
  @Author : INIC
  ******************/
  const commonBreakDown = (vehicleDetail, age = 0) => {
    let selectedStartTimeValue = "";
    let selectedEndTimeValue = "";


    if (isPageLoad) {
      const timeArr = get_cookie("timerange") ? get_cookie("timerange").split("|") : [];
      if (timeArr[0] && timeArr[1]) {
        selectedStartTimeValue = timeArr[0];
        selectedEndTimeValue = timeArr[1];
        setStartTimeDefaultValue(selectedStartTimeValue);
        setEndTimeDefaultValue(selectedEndTimeValue);
        setIsPageLoad(false);
      } else if (router?.query?.booked_id) {
        const arr1 = bookedTimeDateDetail.bookedStartTime.split("-");
        selectedStartTimeValue = parseInt(arr1[0]);
        const arr2 = bookedTimeDateDetail.bookedEndTime.split("-");
        selectedEndTimeValue = parseInt(arr2[0]);
        setStartTimeDefaultValue(selectedStartTimeValue);
        setEndTimeDefaultValue(selectedEndTimeValue);
        setIsPageLoad(false);
      } else {
        // Cookie not written yet - e.g. navigated here right as the
        // previous page's cookie-write effect was still in flight (fast
        // click on a search-results vehicle card). Leave isPageLoad true
        // so a later retry (see the vehicalDetailData effect above) can
        // pick up the cookie once it's actually there, instead of
        // permanently locking in empty time fields.
        selectedStartTimeValue = startTimeDefaultValue;
        selectedEndTimeValue = endTimeDefaultValue;
      }
    } else {
      selectedStartTimeValue = startTimeDefaultValue;
      selectedEndTimeValue = endTimeDefaultValue;
    }

    if (!isFirstTimeLoad) {
      const obj = breakDown(
        vehicleDetail ? vehicleDetail : vehicalDetailData,
        dateObj,
        selectedStartTimeValue,
        selectedEndTimeValue,
        user?.date_of_birth,
        globalSetting,
        age ? age : ageBookedId,
        deliveryFee,
        formik?.values?.one_way_option && returnFee
      );
      setBreakDownObj(obj);
    }
  };

  /*******************
  @purpose : time change handler
  @Parameter : {}
  @Author : INIC
  ******************/
  const parentTimeChangeHandler = (index, currentObjName) => {
    if (currentObjName != "endDateTime") {
      setStartTimeDefaultValue(index);
    } else {
      setEndTimeDefaultValue(index);
    }
  };

  /*******************
  @purpose : open calender and hide calender with time options set
  @Parameter : {}
  @Author : INIC
  ******************/
  const handleClickOpenCalendar = () => {
    setIshowCalendar(!isShowCalendar);
  };

  // See components/vehicle/index.js's handleClickOpenCalendar for why this
  // is state-driven instead of an imperative classList.toggle().
  useEffect(() => {
    document.body.classList.toggle("model-active", isShowCalendar);
    return () => {
      document.body.classList.remove("model-active");
    };
  }, [isShowCalendar]);

  /*******************
  @purpose : Set start date and end date in respective fields
  @Parameter : {dateObj}
  @Author : INIC
  ******************/
  const setStartEndDateOnChange = (dateObj2) => {
    setNoVehicleError("")
    setNoSlotError("")
    set_cookie("timerange", "");
    set_cookie("month_range", "")
    setEndTimeDefaultValue(null)
    setStartTimeDefaultValue(null)
    if (
      dateObj2 &&
      Object.keys(dateObj2).length === 0 &&
      Object.getPrototypeOf(dateObj2) === Object.prototype
    ) {
      setDateObj(stateObj);
      setStartDate("");
      setEndDate("");
      setStartDateTimeOptions([]);
      setEndDateTimeOptions([]);
      setStartTimeDefaultValue(null);
      setEndTimeDefaultValue(null);
    } else {
      setValidStartDate(false);
      setDateObj([dateObj2]);
      setStartDate(format(dateObj2.startDate, "MMM d, yyyy", {}));
      setEndDate(format(dateObj2.endDate, "MMM d, yyyy", {}));
    }
  };

  const homeAddressDeliveryHandler = () => {
    if (user?.state) {
      if (strToLowerCase(user?.state) == currentLocationStateName) {
        setIsShowHomeAddress(true);
      }
    }
  };
  const setAsHomeAddressHandler = async (e) => {
    sethomeAddress(e.target.checked);
    if (e.target.checked) {
      await formik.setFieldValue("address", user?.address);
      await formik.setFieldValue("city", user?.city);
      await formik.setFieldValue("state", user?.state);
      await formik.setFieldValue("zipcode", user?.zipcode);
      await formik.setFieldValue("country", user?.country);
    }
  };

  // email Quote popup
  const [showEmailQuote, setShowEmailQuote] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isWeb, setIsWeb] = useState(false);
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [showFragment, setShowFragment] = useState(false);

  useEffect(() => {
    if (window.screen.width < 992) {
      setIsMobile(true);
      setIsWeb(false);
    } else {
      setIsMobile(false);
      setIsWeb(true);
    }
  }, []);

  const mobileMenuBreakDownHandler = () => {
    if (
      ((user &&
        user.profile_completed &&
        formik.isValid &&
        numValidation.valid &&
        selectedMake &&
        selectedModal &&
        !isReserveEnable) ||
        (formik.isValid &&
          numValidation.valid &&
          selectedMake &&
          selectedModal &&
          !isReserveEnable)) &&
      breakDownObj.days >= vehicalDetailData?.minimum_days
    ) {
      setIsEmailMeShow(true);
    } else {
      setIsEmailMeShow(false);
    }
    handleShow();
  };

  const ageChangeHandler = (e) => {
    ageCal(e.target.value);
  };
  const ageCal = (val) => {
    let age = 0;
    if (val == "18-20") {
      age = 18;
    } else if (val == "21-24") {
      age = 21;
    } else if (val == "25+") {
      age = 25;
    }
    setAge(age);
    commonBreakDown("", age);
  };

  /*******************
  @purpose : Back button handler
  @Parameter : {}
  @Author : INIC
  ******************/
  const backBtnHandler = () => {
    // vehicleBookingBackUrl is set once when the flow is entered (from
    // search-results or a vehicle detail page) and deliberately NOT
    // consumed here, unlike a one-shot cookie - the Pay step's own chevron
    // pushes a fresh /vehiclebooking/[id] entry every time it's clicked
    // (reservationHeader.js), so real browser history isn't a reliable
    // "came from" signal here. Reading (without clearing) this cookie every
    // time means Select always returns to the true entry point regardless
    // of how much Select<->Pay navigation happened in between.
    const backUrl = get_cookie("vehicleBookingBackUrl");
    if (backUrl) {
      router.push(backUrl);
      return;
    }

    let r = "/ca/los-angeles";
    let checkValue = get_cookie("redirectUrl");
    if (checkValue) {
      if (checkValue !== "/") {
        r = checkValue;
      }
    }

    if (vehicalDetailData) {
      const url_str =
        "/" +
        vehicalDetailData?.brand_detail?.slug +
        "/" +
        vehicalDetailData?.category_detail?.slug +
        "/" +
        vehicalDetailData?.slug +
        "/" +
        vehicalDetailData?.slug_id;
      router.push(r + url_str);
    } else {
      router.push("/");
    }
  };

  /*******************
   @Purpose : used for scroll page
   @Parameter : {}
   @Author : INIC
  *******************/
  const [showHeading, setShowHeading] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const didScrollPage = () => {
      const headerStickyOffset = 15;
      if (scrollContainerRef.current.scrollTop > headerStickyOffset) {
        setShowHeading(true);
      } else {
        setShowHeading(false);
      }
    };

    const scrollContainer = scrollContainerRef.current;
    scrollContainer?.addEventListener("scroll", didScrollPage);

    // Cleanup the event listener on component unmount
    return () => {
      scrollContainer?.removeEventListener("scroll", didScrollPage);
    };
  }, []);

  useEffect(() => {
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  useEffect(() => {
    const vSlug = get_cookie("vSlug");
    const bookedId = router?.query?.booked_id;

    if (!vSlug && !bookedId) {
      setShowFragment(true);
    } else {
      setShowFragment(false);
    }
  }, [router?.query]);

  return (
    <DynamicLayout header={false} step="1" onBack={backBtnHandler}>
      {isValidUrl ? (
        <Fragment>
          <div
            className={`inside-page sticky-btm ${isMobileApp === "yes" ? "mb-sticky-btm" : ""
              }`}
          >
            {isMobileApp !== "yes" && (
              <div
                className={`d-flex d-lg-none align-items-center text-center back-to-page ${showHeading ? "sticky-heading" : ""
                  }`}
              >
                <span
                  className="icon icon-left-chevron"
                  onClick={backBtnHandler}
                ></span>

                <span className="back-title w-100">Select Time & Location</span>
              </div>
            )}
            {/* Reserve now - Main content : Start */}
            <section
              className={`reserve-now ${isMobileApp === "yes" ? "mb-disply-h ios-form-scroll pt-0" : ""
                } `}
              ref={scrollContainerRef}
            >
              <div className="custom-container">
                <BookingSteps step="1" />

                <div className="row">
                  <div className="col-lg-7 order-1 order-lg-0">
                    {showFragment && (
                      <Fragment>
                        {/* <div className="booking-filed time-range time-range-mb mt-space"> */}
                        <div className="booking-filed time-range time-range-mb mt-space-0">
                          <h5>Select Vehicle</h5>
                          {/* Makes Select */}
                          <div className="d-flex input-field select-vehicle">
                            <div className="floating-form">
                              <div className="form-group p-0">
                                <MakesSelect
                                  brandList={brandList}
                                  setSelectedMake={setSelectedMake}
                                  selectedMake={selectedMake}
                                  currentLocationId={currentLocationId}
                                  setSelectedModal={setSelectedModal}
                                  setVehicalDetailData={setVehicalDetailData}
                                  setNoSlotError={setNoSlotError}
                                  setNoVehicleError={setNoVehicleError}
                                  setDateObj={setDateObj}
                                  setStartDate={setStartDate}
                                  setStartTimeDefaultValue={setStartTimeDefaultValue}
                                  setEndTimeDefaultValue={setEndTimeDefaultValue}
                                  setEndDate={setEndDate}
                                />
                              </div>
                            </div>
                            <div className="floating-form">
                              <div className="form-group p-0">
                                <ModelSelect
                                  brandVehicleList={brandVehicleList}
                                  selectedModal={selectedModal}
                                  setSelectedModal={setSelectedModal}
                                  setVehicalDetailData={setVehicalDetailData}
                                  changeTimeBreakDown={changeTimeBreakDown}
                                  setStartDate={setStartDate}
                                  setStartTimeDefaultValue={setStartTimeDefaultValue}
                                  setEndTimeDefaultValue={setEndTimeDefaultValue}
                                  setEndDate={setEndDate}
                                  setStartDateTimeOptions={
                                    setStartDateTimeOptions
                                  }
                                  setNoSlotError={setNoSlotError}
                                  setNoVehicleError={setNoVehicleError}
                                  setDateObj={setDateObj}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="dth-mg mb-0">
                          <hr className="thin-br mb-0 mt-20" />
                        </div>
                      </Fragment>
                    )}
                    <div className="booking-filed time-range">
                      <h5 className="mb-16">When & Where</h5>
                      <Form className="select-date-range">
                        <div className="d-flex input-field">
                          <div className="floating-form">
                            <Form.Group
                              controlId="startDate"
                              className="floating-form-group"
                              onClick={handleClickOpenCalendar}
                            >
                              <Form.Control
                                type="text"
                                className="floating-input pe-none"
                                placeholder="Start Date"
                                name="startDate"
                                defaultValue={startDate}
                              />
                              <Form.Label className="floating-label">
                                Start Date*
                              </Form.Label>
                            </Form.Group>
                            {validStartDate && (
                              <span className="error-msg d-block">
                                {VALID_START_DATE}
                              </span>
                            )}
                          </div>
                          <div className="floating-form">
                            <TimePicker
                              timeOptions={startDateTimeOptions}
                              defaultValue={startTimeDefaultValue}
                              setStartTimeDefaultValue={setStartTimeDefaultValue}
                              parentTimeChangeHandler={parentTimeChangeHandler}
                              currentObjName="startDateTime"
                              selectedDate={startDate}
                              selectedStartDate={startDate}
                              startTimeDefaultValue={startTimeDefaultValue}
                              endTimeDefaultValue={endTimeDefaultValue}
                              setNoSlotError={setNoSlotError}
                              isShowCalendar={isShowCalendar}
                            />
                          </div>
                        </div>
                        <div className="d-flex input-field">
                          <div className="floating-form">
                            <Form.Group
                              controlId="endDate"
                              className="floating-form-group"
                              onClick={handleClickOpenCalendar}
                            >
                              <Form.Control
                                type="text"
                                className="floating-input pe-none"
                                placeholder="End Date"
                                name="endDate"
                                defaultValue={endDate}
                              />
                              <Form.Label className="floating-label">
                                End Date*
                              </Form.Label>
                            </Form.Group>
                          </div>
                          <div className="floating-form">
                            <TimePicker
                              timeOptions={endDateTimeOptions}
                              defaultValue={endTimeDefaultValue}
                              startTimeDefaultValue={startTimeDefaultValue}
                              parentTimeChangeHandler={parentTimeChangeHandler}
                              currentObjName="endDateTime"
                              selectedDate={endDate}
                              setEndTimeDefaultValue={setEndTimeDefaultValue}
                              endTimeDefaultValue={endTimeDefaultValue}
                              selectedEndDate={endDate}
                              selectedStartDate={startDate}
                              setNoSlotError={setNoSlotError}
                              setIsReserveEnable={setIsReserveEnable}
                              isShowCalendar={isShowCalendar}
                            />
                          </div>
                        </div>
                      </Form>

                      {vehicleAvablityError && (
                        <span className="error-msg d-block">
                          {vehicleAvablityError}
                        </span>
                      )}

                    </div>
                    {/*                     {isMobile && <div className="thick-devide mt-8"></div>}{" "}
                     */}{" "}
                    {selectedMake && selectedModal && !isReserveEnable && (
                      <PickupAddress
                        formik={formik}
                        homeAddress={homeAddress}
                        currentLocationStateName={currentLocationStateName}
                        state={state}
                        countryOptions={countryOptions}
                        setStateShortName={setStateShortName}
                        setCurrentLocationStateName={
                          setCurrentLocationStateName
                        }
                        setDeliveryFee={setDeliveryFee}
                        setReturnFee={setReturnFee}
                        deliveryFee={deliveryFee}
                        returnFee={returnFee}
                        globalSetting={globalSetting}
                        vehicalDetailData={vehicalDetailData}
                        setDeliveryMiles={setDeliveryMiles}
                        setReturnMiles={setReturnMiles}
                        setDropoffStateName={setDropoffStateName}
                        setDropoffStateShortName={setDropoffStateShortName}
                        isMobile={isMobile}
                      />
                    )}
                    {/* Dropoff address code end here */}
                    {/* Personal Information */}
                    {(!user &&
                      !user.profile_completed &&
                      selectedMake &&
                      selectedModal &&
                      !isReserveEnable) && (
                        <>
                          <div className="dth-mg mb-0">
                            <hr className="solid-br mb-0" />
                          </div>
                          <div className="booking-filed">
                            <h5>Customer Info</h5>

                            <Form className="select-date-range mb-sm-10">
                              <div className="d-flex input-field">
                                <div className="floating-form">
                                  <Form.Group controlId="firstName">
                                    <Form.Control
                                      type="text"
                                      className="floating-input"
                                      placeholder="Enter first name"
                                      name="first_name"
                                      onChange={formik?.handleChange}
                                      value={formik?.values["first_name"]}
                                    />
                                    <Form.Label className="floating-label">
                                      First name*
                                    </Form.Label>
                                  </Form.Group>
                                  {formik.touched.first_name &&
                                    formik.errors.first_name && (
                                      <span className="error-msg d-block">
                                        {formik?.errors?.first_name}
                                      </span>
                                    )}
                                </div>
                                <div className="floating-form">
                                  <Form.Group controlId="lastName">
                                    <Form.Control
                                      type="text"
                                      className="floating-input"
                                      placeholder="Enter last name"
                                      name="last_name"
                                      onChange={formik?.handleChange}
                                      value={formik?.values["last_name"]}
                                    />
                                    <Form.Label className="floating-label">
                                      Last name*
                                    </Form.Label>
                                  </Form.Group>
                                  {formik.touched.last_name &&
                                    formik.errors.last_name && (
                                      <span className="error-msg d-block">
                                        {formik?.errors?.last_name}
                                      </span>
                                    )}
                                </div>
                              </div>

                              <div className="d-flex input-field">
                                <div className="floating-form">
                                  <Form.Group
                                    controlId="email"
                                    className="floating-form-group"
                                  >
                                    <Form.Control
                                      // ref={emailRef}
                                      type="email"
                                      className="floating-input"
                                      name="email"
                                      placeholder="Enter email address"
                                      value={values.email}
                                      onBlur={formik.handleBlur}
                                      onChange={(e) =>
                                        formik.setFieldValue(
                                          "email",
                                          e.target.value.toLowerCase()
                                        )
                                      }
                                    />
                                    <Form.Label className="floating-label">
                                      Email Address*
                                    </Form.Label>
                                  </Form.Group>
                                  {formik.touched.email &&
                                    formik.errors.email && (
                                      <span className="error-msg d-block">
                                        {formik?.errors?.email}
                                      </span>
                                    )}
                                </div>
                              </div>

                              <div className="d-flex input-field align-items-start phone-boxwrap">
                                <div className="floating-form">
                                  <Form.Group
                                    controlId="phoneNumber"
                                    className="floating-form-group inner-phone-number"
                                  >
                                    <TelInputFunctional
                                      fieldName="contact_number"
                                      className="floating-input"
                                      value={value}
                                      setValue={setValue}
                                      handleInputChange={handleInputChange}
                                      label={"Phone Number* "}
                                      setNumValidation={setNumValidation}
                                      setcountryIso={setcountryIso}
                                      country={countryFlag && countryFlag}
                                    />
                                  </Form.Group>

                                  {numValidation?.error && (
                                    <span className="error-msg d-block">
                                      {numValidation?.error}
                                    </span>
                                  )}
                                </div>
                              </div>
                              <div className="d-flex input-field align-items-start ">
                                <div className="floating-form">
                                  <Form.Group
                                    // ref={ref}
                                    controlId="ageSelect"
                                    className={`floating-form-group select-option age-select label-top modified-select ${values.age ? "label-float" : ""
                                      }`}
                                  >
                                    <Form.Control
                                      as="select"
                                      // defaultValue="Select Age"
                                      className="floating-input cursor-pointer"
                                      name="age"
                                      menuIsOpen
                                      onChange={(e) => {
                                        formik.handleChange(e);
                                        ageChangeHandler(e);
                                      }}
                                      value={values.age}
                                    >
                                      <option value="">Select value</option>
                                      <option value="18-20">18-20</option>
                                      <option value="21-24">21-24</option>
                                      <option value="25+">25+</option>
                                    </Form.Control>
                                    <Form.Label className="floating-label">
                                      {values.age ? "Age*" : "Select Age*"}
                                    </Form.Label>
                                  </Form.Group>
                                </div>
                              </div>
                            </Form>
                          </div>
                          <div id="mobileAppSpace"></div>
                        </>
                      )}
                    {isWeb && breakDownObj?.days < vehicalDetailData?.minimum_days && (
                      <span className="text-danger font-12 ff-hel-med d-block">
                        {minimumDayErrorMessage(
                          vehicalDetailData?.minimum_days
                        )}
                      </span>
                    )}
                    {noSlotError && endDate && <span className="text-danger font-12 ff-hel-med d-block">
                      {noSlotError}
                    </span>}
                    {noVehicleError && noVehicleError && <span className="text-danger font-12 ff-hel-med d-block">
                      {noVehicleError}
                    </span>}
                    {showCompleteProfileModal && (
                      <span className="text-danger font-12 ff-hel-med d-block">
                        Please complete your profile to proceed.{" "}
                        <Link
                          href="/personal-details"
                          className="text-primary text-decoration-underline"
                        >
                          complete profile
                        </Link>
                      </span>
                    )}
                    <Button
                      variant="primary"
                      className={`w-100 btn-primary-light mt-4 ff-hel-med d-none d-lg-flex align-items-center justify-content-center gtStep1 ${loaders && loaders?.button_loader ? "btn-loader-size-s" : ""}`}
                      onClick={() => {
                        if (user && !user?.profile_completed) {
                          setShowCompleteProfileModal(true);
                          return;
                        }
                        formik.handleSubmit();
                      }}
                      disabled={
                        loaders && loaders?.button_loader || !(
                          selectedMake &&
                          selectedModal &&
                          !isReserveEnable && !noSlotError &&
                          breakDownObj.days >= vehicalDetailData?.minimum_days
                        )
                      }
                    >
                      {loaders && loaders?.button_loader ? <ButtonLoader isVehicle="vehicleBooking" /> : "Next"}
                    </Button>
                  </div>
                  {vehicalDetailData && startDate && endDate && (
                    <div className="col-lg-5 mb-lg-0 order-0 order-lg-1">
                      <div className="booking-card reserve-card-details mb-hr sticky-box border-round padding-0">
                        <CarDetailInfo
                          vehicalDetailData={vehicalDetailData}
                          days={breakDownObj?.days}
                          formik={formik}
                          stateShortName={stateShortName}
                          dropoffStateShortName={dropoffStateShortName}
                          startDate={startDate}
                          startTimeDefaultValue={parseInt(startTimeDefaultValue?.split(":")[0], 10)}
                          endDate={endDate}
                          endTimeDefaultValue={parseInt(endTimeDefaultValue?.split(":")[0], 10)}
                          isShowEmailMeQuotaInPriceDetail={
                            ((user &&
                              user.profile_completed &&
                              formik.isValid &&
                              numValidation.valid &&
                              selectedMake &&
                              selectedModal &&
                              !isReserveEnable) ||
                              (formik.isValid &&
                                numValidation.valid &&
                                selectedMake &&
                                selectedModal &&
                                !isReserveEnable)) &&
                            isWeb &&
                            breakDownObj.days >= vehicalDetailData?.minimum_days
                          }
                        />
                        {/* Personal info */}
                        {user?.first_name && (
                          <Fragment>
                            <hr className="web-hr" />
                            <div className="user-booking-details">
                              <ul className="list-unstyled mb-0 personal-info">
                                <li>
                                  <span className="icon icon-profile-new"></span>
                                  <div className="user-title open w-100">
                                    <span className="user-name w-100">
                                      <span className="text-username">
                                        {user.first_name} {user.last_name}
                                      </span>
                                      {formik?.values?.startAge && (
                                        <>
                                          <span className="vtr-line"> | </span>
                                          <span className="age-user">
                                            {formik?.values?.startAge}
                                          </span>
                                        </>
                                      )}
                                    </span>
                                    <div
                                      className="email-mobile"
                                      style={{ textTransform: "none" }}
                                    >
                                      {user?.contact_number && (
                                        <a href="javascript:void(0);">
                                          {user?.country_code?.startsWith("++")
                                            ? user.country_code.replace("++", "+")
                                            : user?.country_code +
                                            " " +
                                            removeFrontZeroFromPhoneNo(
                                              user?.contact_number
                                            )}
                                        </a>
                                      )}
                                      {user?.contact_number && user?.email && (
                                        <span className="vtr-line"> | </span>
                                      )}
                                      {user?.email && (
                                        <a href="javascript:void(0);">
                                          {user?.email}
                                        </a>
                                      )}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </Fragment>
                        )}

                        {/* Desktop view : Rental charges */}
                        <PriceDetail
                          breakDownObj={breakDownObj}
                          emailMeQuota={emailMeQuota}
                          deliveryType={values.delivery_type}
                          start_address={values.start_address}
                          return_address={values.return_address}
                          is_pickup_selected={values?.is_pickup_selected}
                          one_way_option={values?.one_way_option}
                          isShowEmailMeQuotaInPriceDetail={
                            ((user &&
                              user.profile_completed &&
                              formik.isValid &&
                              numValidation.valid &&
                              selectedMake &&
                              selectedModal &&
                              !isReserveEnable) ||
                              (formik.isValid &&
                                numValidation.valid &&
                                selectedMake &&
                                selectedModal &&
                                !isReserveEnable)) &&
                            isWeb &&
                            breakDownObj.days >= vehicalDetailData?.minimum_days
                          }
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-lg-12 order-0 order-lg-3">
                    {isMobile && vehicalDetailData && startDate && endDate && (
                      <div className="dth-mg">
                        <div className="thick-devide mt-0 mb-0 dth-mg-child"></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
            {/* Reserve now - Main content : End */}

            {/* Mobile bottom button */}
            <div className={`d-flex d-lg-none justify-content-between align-items-center bottom-filed safe-area-bottom ${isShowCalendar ? "scroll-bottom" : ""}`}>
              <span className="d-flex align-items-start flex-column car-price">
                {breakDownObj && !isNaN(breakDownObj?.totalCharge) && (
                  <Fragment>
                    <span className="discounted_rate font-20 ff-hel-med">
                      ${formatMoney(breakDownObj?.totalCharge)} <sub>Total</sub>
                    </span>

                    <Button
                      variant="link"
                      className="p-0 link-btn"
                      onClick={mobileMenuBreakDownHandler}
                    >
                      Price Details{" "}
                    </Button>
                  </Fragment>
                )}
              </span>

              <Button
                variant="primary"
                className={`w-100 btn-primary-light d-flex align-items-center justify-content-center gtstep-mobile ${loaders && loaders?.button_loader ? "btn-loader-size-s" : ""}`}
                onClick={() => {

                  if (user && !user?.profile_completed) {
                    setShowCompleteProfileModal(true);
                    return;
                  }
                  formik.handleSubmit();
                }}
                disabled={
                  loaders && loaders?.button_loader || !(
                    selectedMake &&
                    selectedModal &&
                    !isReserveEnable && !noSlotError &&
                    breakDownObj.days >= vehicalDetailData?.minimum_days
                  )
                }
              >
                {loaders && loaders?.button_loader ? <ButtonLoader isVehicle="vehicleBooking" /> : "Next"}
              </Button>
            </div>
          </div>
          <VerifyUserExistOtpModal
            showHandler={verifyUserExistOtp}
            hideHandler={verifyUserExistOtpClose}
            handleOtpSubmit={verfiyUserExistOtpSubmit}
            continueAsGuest={continueAsGuest}
            ResendOtp={ResendOtp}
            verifyOtpError={verifyOtpError}
          // loader={loader}
          />
          {/* break down popup */}
          <BreakDownModal
            showModal={showModal}
            handleClose={handleClose}
            breakDownObj={breakDownObj}
            isEmailMeShow={isEmailMeShow}
            isPromoCodeShow={false}
            emailMeQuota={emailMeQuota}
            deliveryType={values.delivery_type}
            start_address={values?.start_address}
            return_address={values?.return_address}
            is_pickup_selected={values?.is_pickup_selected}
            one_way_option={values?.one_way_option}
          />
          {/* Date Range */}
          {isShowCalendar ? (
            <DateRangePicker
              dateObj={dateObj}
              setDateObj={setDateObj}
              handleClickOpenCalendar={handleClickOpenCalendar}
              setStartEndDateOnChange={setStartEndDateOnChange}
              startTimeOptionsHandler={startTimeOptionsHandler}
              isFirstTimeLoad={isFirstTimeLoad}
              tempDirections="horizontal"
              tempScroll={{ enabled: false }}
              minimumDay={minimumDay}
              selectedStartDate={startDate}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              vehicleId={vehicalDetailData?.id}
              setStartTimeDefaultValue={setStartTimeDefaultValue}
              setEndTimeDefaultValue={setEndTimeDefaultValue}
              minDayError={breakDownObj?.days < vehicalDetailData?.minimum_days ? minimumDayErrorMessage(
                vehicalDetailData?.minimum_days
              ) : ""}
              isAvailable={vehicalDetailData?.availability !== 1}
              isVehcileDetailsPage={true}
            />
          ) : (
            ""
          )}
          {/* after Email me quote popup */}
          <MainModal
            showHandler={showEmailQuote}
            hideHandler={setShowEmailQuote}
            body={<EmailQuoteSuccess />}
            className="email-quote-model centered-modal"
          />
        </Fragment>
      ) : (
        <Fournotfour />
      )
      }


    </DynamicLayout >
  );
};
export default VehicleBooking;
